import { Folder, List } from "react-feather"
import { ACL_READ, ACL_SUBJECT_CATEGORY } from "@configs/acl/constants"

export default [
  {
    id: "category",
    title: "Category",
    icon: <List size={20} />,
    children: [
      {
        id: "divisions",
        title: "Divisions",
        icon: <Folder size={12} />,
        children: [
          {
            id: "countries",
            title: "Countries",
            icon: <Folder size={12} />,
            navLink: "/category/divisions/countries",
            action: ACL_READ,
            resource: ACL_SUBJECT_CATEGORY
          },
          {
            id: "provinces",
            title: "Provinces",
            icon: <Folder size={12} />,
            navLink: "/category/divisions/provinces",
            action: ACL_READ,
            resource: ACL_SUBJECT_CATEGORY
          },
          {
            id: "districts",
            title: "Districts",
            icon: <Folder size={12} />,
            navLink: "/category/divisions/districts",
            action: ACL_READ,
            resource: ACL_SUBJECT_CATEGORY
          },
          {
            id: "wards",
            title: "Wards",
            icon: <Folder size={12} />,
            navLink: "/category/divisions/wards",
            action: ACL_READ,
            resource: ACL_SUBJECT_CATEGORY
          }
        ]
      },
      {
        id: "tax-departments",
        title: "Tax Departments",
        icon: <Folder size={12} />,
        navLink: "/category/tax-departments",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "vss-offices",
        title: "VSS Offices",
        icon: <Folder size={12} />,
        navLink: "/category/vss-offices",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "hospitals",
        title: "Hospitals",
        icon: <Folder size={12} />,
        navLink: "/category/hospitals",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "banks",
        title: "Banks",
        icon: <Folder size={12} />,
        navLink: "/category/banks",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "state-treasurer",
        title: "State-treasurer",
        icon: <Folder size={12} />,
        navLink: "/category/state-treasurer",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "mail-templates",
        title: "Mail Templates",
        icon: <Folder size={12} />,
        navLink: "/category/mail-templates",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "business-types",
        title: "Business Types",
        icon: <Folder size={12} />,
        navLink: "/category/business-types",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      },
      {
        id: "business-fields",
        title: "Business Fields",
        icon: <Folder size={12} />,
        navLink: "/category/business-fields",
        action: ACL_READ,
        resource: ACL_SUBJECT_CATEGORY
      }
    ]
  }
]
